import React, { Component } from 'react';
import { View, ScrollView, Dimensions, StyleSheet } from 'react-native';
import { THEME, COLOR } from '../../constants/styles';

import { CachedImage, CloseButton, ImageView } from '.';
import FullscreenImageSwipeView from './fullscreen_image_swipe_view';

import Navigation from '../../navigation';
import NavBar from '../../navbar';
import Utils from '../../utils';

const CLOSE_BUTTON_HEIGHT = 65;

export default class FullscreenModal extends Component {
  static navigatorStyle = NavBar.hiddenNavbarStyle;

  constructor(props) {
    super(props);

    this.state = {
      rerenderToggle: false,
      scrollEnabled: false,
    };

    this._screenWidth;
    this._screenHeight;

    this._scrollViewRef = null;
    this._swipeRefs = [];
    this._imageRefs = [];
    this._previousImageIndex = null;

    this._didSetInitialScrollPos = false;

    this._selectedImageIndex = props.attachments
      ? this._attachmentIndex(props.attachments, props.attachment)
      : 0;

    this._maxIndex =
      props.attachments && props.attachments.length ? props.attachments.length - 1 : 0;
  }

  handleClosePress = () => {
    Navigation.close(this.props);
  };

  componentDidMount() {
    let { height, width } = Dimensions.get('window');
    this._screenHeight = height;
    this._screenWidth = width;
  }

  handleMomentumScrollEnd = ({ nativeEvent }) => {
    // console.info('handleMomentumScrollEnd');
    let selectedIndex = this._selectedImageIndex;
    let prevIndex = this._previousImageIndex;

    if (selectedIndex !== prevIndex) {
      let imageRef = this._imageRefs[prevIndex];
      imageRef && imageRef.resetZoomSize();
    }
  };

  handleSwipe = (dir) => {
    if (!this._scrollViewRef) return;

    let lastIndex = this._selectedImageIndex;
    const newIndex = lastIndex + dir * -1;

    if (newIndex > this._maxIndex || newIndex < 0) return;

    this._previousImageIndex = this._selectedImageIndex;
    this._selectedImageIndex = newIndex;

    // console.info('handleSwipe', lastIndex, newIndex);

    if (lastIndex !== newIndex) {
      const newX = newIndex * this._screenWidth;

      // this._renderSwipeViewImages([newIndex-1, newIndex, newIndex+1]);
      this._renderSwipeViewImages([newIndex]);
      this._scrollViewRef.scrollTo({ x: newX, animated: true });
    }
  };

  handleLayout = ({ nativeEvent }) => {
    let { height, width } = Dimensions.get('window');

    // handle rotation
    if (this._screenWidth !== width) {
      // trigger re-render so images will be resized upon screen rotation
      this.setState({ rerenderToggle: !this.state.rerenderToggle }, this._initialScrollPos);
    }

    if (!this._didSetInitialScrollPos) {
      this._didSetInitialScrollPos = true;

      this._initialScrollPos();
    }
  };

  _renderSwipeViewImages(indices) {
    if (!this._swipeRefs) return;
    indices.forEach((i) => {
      const swipeRef = this._swipeRefs[i];
      swipeRef && swipeRef.renderChild();
    });
  }

  _initialScrollPos = () => {
    if (!this._scrollViewRef) return;

    const scrollPos = this._screenWidth * this._selectedImageIndex;

    this._scrollViewRef.scrollTo({ x: scrollPos, animated: false });

    // this._renderSwipeViewImages([attachmentIndex-1, attachmentIndex, attachmentIndex+1]);
    this._renderSwipeViewImages([this._selectedImageIndex]);
  };

  _attachmentIndex(attachments, attachment) {
    let i;
    for (i = 0; i < attachments.length; i++) {
      if (attachments[i].objectId === attachment.objectId) break;
    }

    // not found
    if (i >= attachments.length) return null;
    return i;
  }

  renderImageFromURI(imageURI, refIndex) {
    // imageURI = 'http://www.noimagehere.com/noimagehere.png';
    return (
      <ImageView
        ref={(ref) => (this._imageRefs[refIndex] = ref)}
        flexSize={true}
        imageUri={imageURI}
        spinnerColor="white"
        resizeMode="contain"
        onPress={null}
        onClose={this.handleClosePress}
        onSwipeHorizontal={this.handleSwipe}
      />
    );
  }

  renderImage(attachment, refIndex) {
    return (
      <CachedImage
        ref={(ref) => (this._imageRefs[refIndex] = ref)}
        attachment={attachment}
        isThumb={false}
        flexSize={true}
        spinnerColor="white"
        resizeMode="contain"
        onPress={null}
        onClose={this.handleClosePress}
        onSwipeHorizontal={this.handleSwipe}
      />
    );
  }

  renderContent() {
    let { height, width } = Dimensions.get('window');
    this._screenWidth = width;
    this._screenHeight = height;

    const { attachments, attachment, imageURI } = this.props;
    const renderAsList = !!attachments;

    return (
      <ScrollView
        ref={(ref) => (this._scrollViewRef = ref)}
        pagingEnabled={true}
        horizontal={true}
        bounces={true}
        automaticallyAdjustContentInsets={false}
        scrollsToTop={false}
        scrollEventThrottle={16}
        showsHorizontalScrollIndicator={false}
        directionalLockEnabled={true}
        alwaysBounceVertical={false}
        onMomentumScrollEnd={this.handleMomentumScrollEnd}
        disableScrollViewPanResponder={true}
        scrollEnabled={this.state.scrollEnabled}
      >
        {!!renderAsList &&
          attachments.map((attachment, i) => {
            return (
              <View
                key={`${attachment.fileName}${attachment.objectId}`}
                style={[styles.imageContainer, { width, height }]}
              >
                <FullscreenImageSwipeView ref={(ref) => (this._swipeRefs[i] = ref)}>
                  {this.renderImage(attachment, i)}
                </FullscreenImageSwipeView>
              </View>
            );
          })}

        {!renderAsList && !!attachment && (
          <View style={[styles.imageContainer, { width, height }]}>
            {this.renderImage(attachment, 0)}
          </View>
        )}

        {!!imageURI && (
          <View style={[styles.imageContainer, { width, height }]}>
            {this.renderImageFromURI(imageURI, 0)}
          </View>
        )}
      </ScrollView>
    );
  }

  renderImageContent() {
    let { height, width } = Dimensions.get('window');
    this._screenWidth = width;
    this._screenHeight = height;

    return <View style={[styles.imageContainer, { width, height }]}>{this.renderImage(0)}</View>;
  }

  render() {
    return (
      <View style={styles.container} onLayout={this.handleLayout}>
        {this.renderContent()}
        <CloseButton
          tintColor="white"
          style={styles.closeButtonContainer}
          onPress={this.handleClosePress}
          width={40}
          height={40}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    backgroundColor: COLOR.modalBackground,
  },
  closeButtonContainer: {
    height: CLOSE_BUTTON_HEIGHT,
    width: CLOSE_BUTTON_HEIGHT,
    position: 'absolute',
    top: Utils.isIphone() ? 40 : 0,
    right: 0,
  },
  imageContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
});
